if (!customElements.get('collection-showcase')) {
  customElements.define('collection-showcase', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.collection-showcase__track');
      this.controls = this.querySelector('.collection-showcase__controls');
      this.carousel = this.querySelector('.collection-showcase__carousel');
      this.productImage = this.querySelector('.product-featured-image');
      this.items = Array.from(this.track.children);
      this.buttons = Array.from(this.controls.querySelectorAll('button'));
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const direction = Number(button.dataset.direction);
        const step = this.items[0]?.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
        if (!step) return;
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const position = Math.abs(this.track.scrollLeft);
        let target = position + step * direction;
        if (direction > 0 && position >= maxScroll - 1) target = 0;
        if (direction < 0 && position <= 1) target = maxScroll;
        this.track.scrollTo({
          left: Math.max(0, Math.min(target, maxScroll)) * (getComputedStyle(this.track).direction === 'rtl' ? -1 : 1),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }, { signal }));
      this.track.addEventListener('scroll', () => this.updateControls(), { passive: true, signal });
      this.resizeObserver = new ResizeObserver(() => this.updateControls());
      this.resizeObserver.observe(this.track);
      if (this.productImage) this.resizeObserver.observe(this.productImage);
      this.updateControls();
    }

    updateControls() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.controls.hidden = this.items.length <= 5 || maxScroll <= 1;
      if (this.productImage) {
        const imageRect = this.productImage.getBoundingClientRect();
        const carouselRect = this.carousel.getBoundingClientRect();
        this.carousel.style.setProperty('--showcase-arrow-top', `${imageRect.top - carouselRect.top + imageRect.height / 2}px`);
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
